import { render } from "./multi-whitelabel-dialog.vue?vue&type=template&id=3aa70eb6&ts=true"
import script from "./multi-whitelabel-dialog.ts?vue&type=script&lang=ts"
export * from "./multi-whitelabel-dialog.ts?vue&type=script&lang=ts"

import "./multi-whitelabel-dialog.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__